import { render, staticRenderFns } from "./ClinicsModule.vue?vue&type=template&id=477bfd94&scoped=true&"
import script from "./ClinicsModule.vue?vue&type=script&lang=js&"
export * from "./ClinicsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477bfd94",
  null
  
)

export default component.exports